// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--L55gY";
export var get_started_button_responsive = "Layout-module--get_started_button_responsive--wQzvH";
export var hiding_overflow = "Layout-module--hiding_overflow--QWLY9";
export var main_content = "Layout-module--main_content--uR-43";